import axios from 'axios'

// 创建axios实例
const request = axios.create({
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器 - 自动添加token
request.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('请求拦截器错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器 - 统一处理响应
request.interceptors.response.use(
  response => {
    // 直接返回响应数据
    return response
  },
  error => {
    console.error('响应拦截器错误:', error)
    
    // 处理401未授权错误（token过期）
    if (error.response && error.response.status === 401) {
      // 清除本地存储的token和用户信息
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('rememberedUsername')
      
      // 触发全局登出事件
      window.dispatchEvent(new CustomEvent('token-expired'))
      console.warn('Token已过期，自动退出登录')
      
      // 显示提示信息
      alert('登录已过期，请重新登录')
      
      // 刷新页面，让App.vue重新检查登录状态，自动跳转到登录页面
      window.location.reload()
      
      // 阻止后续的错误处理
      return Promise.reject(new Error('Token已过期，已跳转到登录页面'))
    }
    
    return Promise.reject(error)
  }
)

export default request
